module.exports = __webpack_public_path__ + "img/迁安炼钢.1ae0c2ee.jpg";